import styled, { css } from 'styled-components'

interface ITicketProperties {
    isThumbnail?: boolean
}

const TicketUrlAssetMixin = css`
    border: none;
    border-radius: 0.75rem;
    height: 100%;
    width: 100%;
`
const TicketThumbnail = css`
    width: 228px;
    min-height: 228px;
    border: none;
`

export const ContainerTicket = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    height: 64px;
    border-radius: 0.75rem;
    @media only screen and (min-width: 810px) {
        border-radius: 0.75rem;
        height: 100%;
        max-height: 398px;
        width: 100%;
    }
`
export const ContainerTicketSuccess = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    height: 250px;
    border-radius: 0.75rem;

    @media only screen and (min-width: 810px) {
        border-radius: 0.75rem;
        width: 100%;
    }
`

export const TicketFrame = styled.iframe<ITicketProperties>`
    ${properties => (properties.isThumbnail ? TicketThumbnail : TicketUrlAssetMixin)}
`

export const TicketVideo = styled.video<ITicketProperties>`
    ${properties => (properties.isThumbnail ? TicketThumbnail : TicketUrlAssetMixin)}
    user-select: none;
    display: block;
    width: 100%;
    border-radius: inherit;
    object-position: center center;
    max-height: inherit;
    object-fit: contain;
    image-rendering: auto;
`

export const TicketImage = styled.img<ITicketProperties>`
    ${properties => (properties.isThumbnail ? TicketThumbnail : TicketUrlAssetMixin)}
    user-select: none;
    display: block;
    width: 100%;
    border-radius: inherit;
    object-position: center center;
    max-height: inherit;
    object-fit: contain;
    image-rendering: auto;
`

export const TicketTag = styled.span`
    display: flex;
    position: absolute;
    left: 12px;
    top: 12px;
    padding: 8px 16px;

    font-family: 'Work Sans', 'Spartan', sans-serif;
    font-size: 12px;
    font-weight: 700;

    border-radius: 100px;
    background: #161616;
    color: #fff;
`
